import { PANELMANAGER_SHOW_PANELPROPSDIALOG } from '../../constants';

export type ShowPanelPropsDialogAction = {
    type: typeof PANELMANAGER_SHOW_PANELPROPSDIALOG;
    panelKey: string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {ShowPanelPropsDialogAction}
 */
export default function showPanelPropsDialog( panelKey: string ): ShowPanelPropsDialogAction {
    return {
        type: PANELMANAGER_SHOW_PANELPROPSDIALOG,
        panelKey
    };
}
